import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import IssuedChequeListView from 'src/sections/issued-cheque/view/issued-cheque-list-view';

export default function IssuedChequeListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Issued Cheques</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_ISSUED_CHEQUE,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <IssuedChequeListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
